export enum StatusType {
  Completed,
  NotCompleted,
  NotStarted,
  OnTrack,
  Behind,
  Postponed,
  Cancel,
}
